<template>
    <div class="ck-form" :class="{ 'ck-form-right': labelPosition === 'right',
                    'ck-form-top': labelPosition === 'top',
                    'ck-form-left': labelPosition === 'left'}">
        <form>
            <slot></slot>
        </form>
    </div>
</template>

<script>
import Vue from 'vue';
export default Vue.component('ck-form', {
    props: {
        formModel: {
            type: Object,
            default: () => null
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        validators: {
            type: Array,
            default: () => { }
        },
        labelPosition: {
            type: String,
            default: 'right'
        }
    },

    data: function () {
        return {
            childValidators: {}
        }
    },

    computed: {
        computedValidators() {
            if (!this.validators) return [];
            return Array.isArray(this.validators) ? this.validators : [this.validators];
        },
        flattenValidators() {
            return _.filter( this.computedValidators.concat(_.flatten(_.map(this.childValidators, 'computedValidators'))), (item) => !!item );
        }
    },

    mounted: function () {
        this.initialize = true;
    },

    methods: {
        validate: function (callback) {
            _.each(this.flattenValidators, (item, key) => {
                this._validate('submit', item);
                this._validate('change', item);
                this._validate('focus', item);
            });
            let result = _.every(this.flattenValidators, (item) => item.isValid);

            callback(result);
        },
        register(childComponent) {
            this.$set(this.childValidators, childComponent._uid, childComponent);
        },
        unregister(childComponent) {
            delete this.childValidators[childComponent._uid];
        },
        _specificValidate: function (trigger, uid) {
            //todo filter
            if (this.initialize) {
                _.each(this.childValidators[uid].computedValidators, (item) => {
                    if (item.trigger === trigger) {
                        this.$set(item, 'isDirty', true);
                        this.$set(item, 'isValid', item.validator(item.model));
                    }
                });
            }
        },
        _validate: function (trigger, validator) {
            if (validator.trigger === trigger) {
                this.$set(validator, 'isDirty', true);
                console.log(validator.validator(validator.model));
                console.log(validator);
                this.$set(validator, 'isValid', validator.validator(validator.model));
            }
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ck-form/ck-form.vue